import { render, staticRenderFns } from "./pickupDetail.vue?vue&type=template&id=ee716408&scoped=true&"
import script from "./pickupDetail.vue?vue&type=script&lang=js&"
export * from "./pickupDetail.vue?vue&type=script&lang=js&"
import style0 from "./pickupDetail.vue?vue&type=style&index=0&id=ee716408&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee716408",
  null
  
)

export default component.exports